import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function FleetDeal() {
    const navigate = useNavigate();
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            data-testid="fleet-deal-banner"
            className="border-y-2 border-[#0E0D0C] bg-[#0055A5] px-4 py-4"
        >
            <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-6 gap-y-3 text-center">
                <p className="font-display text-xl tracking-widest text-[#F6F2E8] sm:text-2xl">
                    ★ FLEETS WELCOME — EVERY TRUCK JUST{" "}
                    <span className="text-[#E5A93C]">$5/MO</span> — ONE FLAT RATE, NO GAMES ★
                </p>
                <button
                    data-testid="fleet-deal-cta"
                    onClick={() => navigate("/fleet")}
                    className="btn-press font-display border-2 border-[#0E0D0C] bg-[#E5A93C] px-5 py-2 text-base tracking-widest text-[#161413] shadow-[3px_3px_0px_#0E0D0C]"
                >
                    REGISTER YOUR FLEET
                </button>
            </div>
        </motion.div>
    );
}
